export default "__VITE_ASSET__DWrGPpJJ__"